import { Link, useNavigate } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { api } from "@/lib/api";
import { OverviewTab } from "@/components/admin/OverviewTab";
import { ProductsTab } from "@/components/admin/ProductsTab";
import { CouponsTab } from "@/components/admin/CouponsTab";
import { OrdersTab } from "@/components/admin/OrdersTab";
import { WaitlistTab } from "@/components/admin/WaitlistTab";
import { CategoriesTab } from "@/components/admin/CategoriesTab";

const TABS = [
  ["overview", "Overview", "admin-nav-analytics"],
  ["products", "Artworks", "admin-nav-products"],
  ["categories", "Categories", "admin-nav-categories"],
  ["orders", "Orders", "admin-nav-orders"],
  ["coupons", "Coupons", "admin-nav-coupons"],
  ["waitlist", "Waitlist", "admin-nav-waitlist"],
];

export default function AdminDashboard() {
  const navigate = useNavigate();
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-[#F7F4EE]" data-testid="admin-dashboard">
      <header className="border-b border-[#E5E0D8] bg-[#FDFBF7]">
        <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-5">
          <div className="flex items-center gap-6">
            <Link to="/" className="text-[13px] tracking-[0.42em]" data-testid="admin-view-site">LASZLO ABONYI</Link>
            <span className="eyebrow hidden sm:inline">Studio admin</span>
          </div>
          <button onClick={logout} className="text-[12px] uppercase tracking-[0.2em] text-[#5A626A] hover:text-[#1A1A1A]" data-testid="admin-logout-btn">Sign out</button>
        </div>
      </header>
      <div className="mx-auto max-w-[1400px] px-6 py-10">
        <Tabs defaultValue="overview">
          <TabsList className="flex h-auto w-full flex-wrap justify-start gap-1 rounded-none bg-transparent p-0">
            {TABS.map(([v, l, id]) => (
              <TabsTrigger key={v} value={v} data-testid={id} className="rounded-none border-b border-transparent px-4 py-2 text-[12px] uppercase tracking-[0.18em] data-[state=active]:border-[#1A1A1A] data-[state=active]:bg-transparent data-[state=active]:shadow-none">
                {l}
              </TabsTrigger>
            ))}
          </TabsList>
          <TabsContent value="overview" className="mt-8"><OverviewTab /></TabsContent>
          <TabsContent value="products" className="mt-8"><ProductsTab /></TabsContent>
          <TabsContent value="orders" className="mt-8"><OrdersTab /></TabsContent>
          <TabsContent value="waitlist" className="mt-8"><WaitlistTab /></TabsContent>
          <TabsContent value="categories" className="mt-8"><CategoriesTab /></TabsContent>
          <TabsContent value="coupons" className="mt-8"><CouponsTab /></TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
